import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { StarredButtonContext } from "./starred-button-context";
import { StarredIcon } from "./starred-icon";
import {
  optionStarredTranslationKeyByValue,
  starredModes,
} from "./starred-utils";

export const StarredDropdownArea: FC = () => {
  const { t } = useTranslation();
  const {
    anchorRef,
    closePopover,
    handleItemClick,
    isPopoverOpen,
    starredDisplayMode,
    isDataReloading,
  } = useContext(StarredButtonContext);

  const onClickAwayHandler = (event: MouseEvent | TouchEvent): void => {
    closePopover();
  };

  return (
    <Popper
      open={isPopoverOpen || false}
      anchorEl={anchorRef.current}
      transition
      disablePortal
      placement="bottom-start"
      className="starred-popper"
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps}>
          <Paper elevation={8}>
            <ClickAwayListener onClickAway={onClickAwayHandler}>
              <MenuList data-e2e="starred-dropdown-list" autoFocusItem>
                {starredModes.map(starredMode => (
                  <MenuItem
                    key={starredMode}
                    sx={{ gap: "8px" }}
                    selected={starredDisplayMode === starredMode}
                    className="starred-dropdown-item"
                    onClick={event => handleItemClick(event, starredMode)}
                    disabled={isDataReloading}
                  >
                    <StarredIcon starredDisplayMode={starredMode} />
                    <span>
                      {t(optionStarredTranslationKeyByValue(starredMode))}
                    </span>
                    {/* highly likely will be needed soon: <strong>{ridesCountByStarredMode(starredMode)}</strong> */}
                  </MenuItem>
                ))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};
